
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import {
  ginzaMugitooliveAburasobaImage,
  ginzaMugitooliveMugitooliveFrontImage,
  ginzaMugitooliveMugitooliveInImage,
  ginzaMugitooliveMugitooliveMichelinImage,
  ginzaMugitooliveMugitooliveTsukemenImage,
} from "@src/constants/images";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import LazyImage from "@src/components/LazyImage";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
export const meta = {
  path: "/media/harajuku/mugitoolive",
  title: "【銀座No.2】行列必須の「むぎとオリーブ」の洋風ラーメンとは？",
  description: "ラーメンの激戦区と言われる銀座で不動の地位を確立する人気店「むぎとオリーブ」についてご紹介します。あの格付けサイトにも掲載された実績のあるラーメン、つけ麺、油そばを写真付きで紹介し、連日できる行列情報についても記載をしております。気になっている方は、是非一度ご一読ください。",
  topImg: ginzaMugitooliveAburasobaImage,
  author: murakamiMasanori,
  tags: ["銀座", "ラーメン", "行列店", "人気店", "お店の紹介", "デート", "おしゃれな内装", "食べログ高評価", "ミシュラン掲載"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`一風変わった洋風な名前から、日本のラーメン店とは一線を隠す存在なのが「むぎとオリーブ」。`}</p>
    <p>{`あの格付けサイトにも掲載される実績があり、ラーメンも普通の出汁とは違った独特の味わいなのが特徴。
連日行列のできるラーメン店だからこその行列情報も記載しているので、足を運びたいか方は是非ご一読ください。`}</p>
    <h2>{`むぎとオリーブとは`}</h2>
    <h3>{`銀座 SIX 目の前のラーメン店`}</h3>
    <LazyImage img={ginzaMugitooliveMugitooliveFrontImage} alt="むぎとオリーブ店前" mdxType="LazyImage" />
    <p>{`銀座の中心地で最も人が賑わうエリアの銀座 SIX の目の前にこじんまりと店舗を構えているのが「むぎとオリーブ」。
名前からラーメン店とは想像できない洋風な雰囲気を思わせるラーメン店で、休日は夕方近くまで行列ができるほどの人気店なので、すぐに場所がわかると思います。`}</p>
    <h3>{`あの格付けガイドにも`}</h3>
    <LazyImage img={ginzaMugitooliveMugitooliveMichelinImage} alt="ミシュランにも掲載" mdxType="LazyImage" />
    <p>{`銀座のラーメン食べログ第２位で、百名店に選出されている「むぎとオリーブ」ですが、人気はそこだけにとどまりません。
あの世界的な格付けガイドの`}<strong parentName="p">{`ミシュラン`}</strong>{`にも選出されており、その人気は世界的なレベルまで広がっています。
特に外国人観光客の多い銀座なので、外国人観光客の舌にもフィットするラーメンが、「むぎとオリーブ」です。`}</p>
    <hr></hr>
    <h2>{`豊富なメニュー`}</h2>
    <p>{`「むぎとオリーブ」では、いろんな人の舌に合わせたラーメンが提供されており、選ぶのが迷うほど魅力的にラーメンがたくさん存在します。`}</p>
    <h3>{`ラーメン`}</h3>
    <InstaImage postId="CFjJzPKD8Jp" mdxType="InstaImage" />
    <p>{`「むぎとオリーブ」の名物ラーメンである「蛤 soba」。蛤の出汁がスープに染みているが、具材がスープに混ざると、また違った風味の味を堪能できるのが特徴的。定番の人気ラーメンが食べたい方にはこちらの蛤 soba がオススメです。`}</p>
    <h3>{`つけ麺`}</h3>
    <LazyImage img={ginzaMugitooliveMugitooliveTsukemenImage} alt="つけ麺" mdxType="LazyImage" />
    <p>{`濃厚な出汁と卵の風味がしっかり練り込まれた麺、パプリカをはじめとした洋風な食材もあるつけ麺がこちらです。
レモンをかけるとアクセントのある味わいになり、スープは「the ラーメン」という感じではなく、濃厚でコクがあるのに胃もたれがしない爽やかな風味があるのが特徴。`}</p>
    <p>{`つけ麺好きの方は、新しい発見のある味わいになっているので、ぜひお試し下さい。`}</p>
    <h3>{`油そば`}</h3>
    <LazyImage img={ginzaMugitooliveAburasobaImage} alt="油そば" mdxType="LazyImage" />
    <p>{`油そば専門店ではないにもかかわらず、大人気の油そばも提供しているのが「むぎとオリーブ」の注目を集める一つの理由ではないでしょうか。
つけ麺よりもより麺に卵の風味が加わり、胃もたれしないしっかり味のついた油そばも、洋風な風味を中心に設計されています。`}</p>
    <p>{`いつもとは違う独特の油そばを体感したい方には、一度食べてもらいたい一品です。`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <p>{`席数が少ないこともあり、平日休日問わず行列ができることが多いです。
特に休日は立地的なこともあり、10 人前後の行列ができることがほとんどで、待ち時間は２０〜40 分程度を想定しておけば大丈夫かと思います。
どうしても並びたくない方は、早めのオープン前か、遅めのランチの時間帯に行くと比較的入りやすいことが多いです。`}</p>
    {
      /*//ここにレツミルの行列情報のせたい*/
    }

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;